const config = {
  DOODLY_API_URL: 'http://localhost:8000/api/v1.2',
  API_URL: 'http://localhost:8000/api/marketplace',
  UMBRELLA_API_URL: 'http://localhost:7070',
  APP_ENV: process.env.REACT_APP_ENV,
  STRIPE_PUBLIC_KEY: 'pk_test_71sSf2ehO2KF6SyispmQiMgf00f3pTL23o'
};

switch (process.env.REACT_APP_ENV) {
  case 'prod':
    config.DOODLY_API_URL = 'https://www.doodly.net/api/v1.2';
    config.API_URL = 'https://www.doodly.net/api/marketplace';
    config.UMBRELLA_API_URL = 'https://umbrella-api.voomly.com';
    config.STRIPE_PUBLIC_KEY = 'pk_live_0yXMN2L1IcgbPLWegtiNuBy9';
    break;
  case 'stage':
    config.DOODLY_API_URL = 'https://staging.doodly.net/api/v1.2';
    config.API_URL = 'https://staging.doodly.net/api/marketplace';
    config.UMBRELLA_API_URL = 'https://umbrella-api.voomly-staging.com';
    break;
  case 'dev':
    config.DOODLY_API_URL = 'https://staging.doodly.net/api/v1.2';
    config.API_URL = 'https://staging.doodly.net/api/marketplace';
    config.UMBRELLA_API_URL = 'https://umbrella-api.voomly-dev.com';
    break;
  default:
    break;
}

export default config;
